import React from 'react'
import SelectField from 'material-ui/SelectField';
import * as colors from "material-ui/styles/colors";

const FormSelect = ({
  input,
  label,
  meta: { touched, error },
  onChange,
  children,
  ...custom
}) =>
  <SelectField
    floatingLabelStyle={{color: colors.grey600}}
    floatingLabelFixed
    floatingLabelText={label}
    errorText={touched && error}
    {...input}
    onChange={(e, index, value) => {
      if (onChange) {
        onChange(e, index, value)
      }
      input.onChange(value)
    }}
    children={children}
    {...custom}
  />

export default FormSelect


// WEBPACK FOOTER //
// ./src/components/FormSelect.js